"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.zIndex = {
  modalBackdrop: 1050,
  modalContainer: 1100,
  popper: 1200,
  dropdown: 1300,
  tooltip: 1400
};